import React from 'react';
import { Link } from 'react-router-dom';
import { Search, Rss, BarChart3, Sparkles, Shield, Twitter, FileText, Lock, Mail, MessageCircle, Heart, Hash, Wallet, Plane, Building2, Clock } from 'lucide-react';
import { getAuthToken } from '../utils/auth';
import { buildSeoulMatchUrl } from './SeoulMatchCta';

// 用語ガイド: 以前は検索画面に常時表示していたが、どのページからでも引けるようフッターに常設した。
const GlossaryDetails = () => (
  <details className="rounded-lg border border-white/10 bg-white/5 p-3">
    <summary className="cursor-pointer text-xs font-medium text-rose-50/80">用語ガイド（かんたん説明）</summary>
    <div className="mt-2 text-[11px] text-rose-50/60 space-y-1">
      <p>・みんなの信頼度: 内容や根拠の提出状況などからつけた「ちゃんとしてそう」目安です。</p>
      <p>・バッジ: 根拠画像などを出して運営OKが出た投稿のマークです。</p>
      <p>・ムード: 投稿の雰囲気を「うれしい／イマイチ／どちらでもない」にざっくり分けたものです。</p>
      {!getAuthToken() && (
        <p className="text-rose-300 font-medium pt-1">・ログインすると「クリップ」であとから見返せます。</p>
      )}
    </div>
  </details>
);

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#2b1620] text-rose-50/70 mt-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 sm:py-12">
        {/* モバイル: 省スペース表示 */}
        <div className="sm:hidden space-y-4">
          <div className="flex items-center justify-between gap-3">
            <Link to="/" className="font-rounded text-lg font-black text-white hover:text-rose-300 transition-colors">
              ウラカルテ
            </Link>
            <div className="inline-flex items-center gap-1.5 px-2.5 py-1 bg-white/10 rounded-full text-[11px] text-rose-100/80">
              <Twitter className="w-3 h-3" />
              <span>X API × Gemini</span>
            </div>
          </div>
          <div className="grid grid-cols-2 gap-2">
            <Link to="/feed" className="inline-flex items-center justify-center gap-1.5 px-2 py-2 text-xs rounded-full bg-white/5 text-rose-50/80 hover:text-rose-300 hover:bg-white/10">
              <Rss className="w-3.5 h-3.5" />
              フィード
            </Link>
            <Link to="/search" className="inline-flex items-center justify-center gap-1.5 px-2 py-2 text-xs rounded-full bg-white/5 text-rose-50/80 hover:text-rose-300 hover:bg-white/10">
              <Search className="w-3.5 h-3.5" />
              検索
            </Link>
            <Link to="/procedures" className="inline-flex items-center justify-center gap-1.5 px-2 py-2 text-xs rounded-full bg-white/5 text-rose-50/80 hover:text-rose-300 hover:bg-white/10">
              <Hash className="w-3.5 h-3.5" />
              施術まとめ
            </Link>
            <Link to="/clinics" className="inline-flex items-center justify-center gap-1.5 px-2 py-2 text-xs rounded-full bg-white/5 text-rose-50/80 hover:text-rose-300 hover:bg-white/10">
              <Building2 className="w-3.5 h-3.5" />
              クリニック
            </Link>
            <Link to="/timelines" className="inline-flex items-center justify-center gap-1.5 px-2 py-2 text-xs rounded-full bg-white/5 text-rose-50/80 hover:text-rose-300 hover:bg-white/10">
              <Clock className="w-3.5 h-3.5" />
              経過タイムライン
            </Link>
            <Link to="/terms" className="inline-flex items-center justify-center gap-1.5 px-2 py-2 text-xs rounded-full bg-white/5 text-rose-50/80 hover:text-rose-300 hover:bg-white/10">
              <FileText className="w-3.5 h-3.5" />
              利用規約
            </Link>
            <Link to="/privacy" className="inline-flex items-center justify-center gap-1.5 px-2 py-2 text-xs rounded-full bg-white/5 text-rose-50/80 hover:text-rose-300 hover:bg-white/10">
              <Lock className="w-3.5 h-3.5" />
              プライバシー
            </Link>
            <Link to="/contact" className="inline-flex items-center justify-center gap-1.5 px-2 py-2 text-xs rounded-full bg-white/5 text-rose-50/80 hover:text-rose-300 hover:bg-white/10">
              <Mail className="w-3.5 h-3.5" />
              お問い合わせ
            </Link>
            <Link to="/insights" className="inline-flex items-center justify-center gap-1.5 px-2 py-2 text-xs rounded-full bg-white/5 text-rose-50/80 hover:text-rose-300 hover:bg-white/10">
              まとめ記事
            </Link>
            <Link to="/statistics" className="inline-flex items-center justify-center gap-1.5 px-2 py-2 text-xs rounded-full bg-white/5 text-rose-50/80 hover:text-rose-300 hover:bg-white/10">
              いま話題
            </Link>
            <Link to="/earn" className="inline-flex items-center justify-center gap-1.5 px-2 py-2 text-xs rounded-full bg-white/5 text-rose-50/80 hover:text-rose-300 hover:bg-white/10">
              収益化
            </Link>
            <Link to="/about" className="inline-flex items-center justify-center gap-1.5 px-2 py-2 text-xs rounded-full bg-white/5 text-rose-50/80 hover:text-rose-300 hover:bg-white/10">
              運営について
            </Link>
            <a
              href={buildSeoulMatchUrl('footer_mobile')}
              target="_blank"
              rel="noopener noreferrer"
              className="col-span-2 inline-flex items-center justify-center gap-1.5 px-2 py-2 text-xs rounded-full bg-white/5 text-rose-50/80 hover:text-sky-300 hover:bg-white/10"
            >
              <Plane className="w-3.5 h-3.5" />
              姉妹サービス Seoul Match（韓国ひとり旅の旅仲間）
            </a>
          </div>
          <GlossaryDetails />
          <p className="text-[11px] text-rose-100/40 text-center border-t border-white/10 pt-3">
            &copy; {currentYear} ウラカルテ
          </p>
        </div>

        {/* タブレット以上: 従来表示 */}
        <div className="hidden sm:block">
        {/* メイン：3カラム */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 lg:gap-12">

          {/* ブランド＋サービス説明 */}
          <div className="sm:col-span-2 lg:col-span-1">
            <Link to="/" className="inline-flex items-center gap-1.5 font-rounded text-xl font-black text-white hover:text-rose-300 transition-colors">
              <Heart className="w-4 h-4 fill-rose-400 text-rose-400" aria-hidden />
              ウラカルテ
            </Link>
            <p className="mt-3 text-sm leading-relaxed text-rose-50/60">
              一般的なAIはXの最新投稿にアクセスできません。ウラカルテはX&nbsp;APIで取得した美容口コミをAIが構造化・分析し、信頼できるレビューとして検索できるサービスです。
            </p>
            <div className="mt-4 flex items-center gap-2 text-xs text-rose-50/50">
              <Shield className="w-3.5 h-3.5 flex-shrink-0" />
              <span>エビデンス審査済みの口コミにはバッジが付きます</span>
            </div>
          </div>

          {/* ナビゲーション */}
          <div>
            <h3 className="text-xs font-bold text-rose-200 uppercase tracking-wider mb-4">サービス</h3>
            <ul className="space-y-2.5">
              <li>
                <Link to="/search" className="inline-flex items-center gap-2 text-sm text-rose-50/70 hover:text-rose-300 transition-colors">
                  <Search className="w-3.5 h-3.5" />
                  口コミ検索
                </Link>
              </li>
              <li>
                <Link to="/procedures" className="inline-flex items-center gap-2 text-sm text-rose-50/70 hover:text-rose-300 transition-colors">
                  <Hash className="w-3.5 h-3.5" />
                  施術まとめ
                </Link>
              </li>
              <li>
                <Link to="/clinics" className="inline-flex items-center gap-2 text-sm text-rose-50/70 hover:text-rose-300 transition-colors">
                  <Building2 className="w-3.5 h-3.5" />
                  クリニックから探す
                </Link>
              </li>
              <li>
                <Link to="/timelines" className="inline-flex items-center gap-2 text-sm text-rose-50/70 hover:text-rose-300 transition-colors">
                  <Clock className="w-3.5 h-3.5" />
                  経過タイムライン
                </Link>
              </li>
              <li>
                <Link to="/feed" className="inline-flex items-center gap-2 text-sm text-rose-50/70 hover:text-rose-300 transition-colors">
                  <Rss className="w-3.5 h-3.5" />
                  フィード
                </Link>
              </li>
              <li>
                <Link to="/statistics" className="inline-flex items-center gap-2 text-sm text-rose-50/70 hover:text-rose-300 transition-colors">
                  <BarChart3 className="w-3.5 h-3.5" />
                  いま話題
                </Link>
              </li>
              <li>
                <Link to="/insights" className="inline-flex items-center gap-2 text-sm text-rose-50/70 hover:text-rose-300 transition-colors">
                  <FileText className="w-3.5 h-3.5" />
                  まとめ記事
                </Link>
              </li>
              <li>
                <Link to="/earn" className="inline-flex items-center gap-2 text-sm text-rose-50/70 hover:text-rose-300 transition-colors">
                  <Wallet className="w-3.5 h-3.5" />
                  投稿を収益化
                </Link>
              </li>
              <li>
                <Link to="/ai-analysis" className="inline-flex items-center gap-2 text-sm text-rose-50/70 hover:text-rose-300 transition-colors">
                  <Sparkles className="w-3.5 h-3.5" />
                  AI分析
                </Link>
              </li>
              <li>
                <Link to="/chat" className="inline-flex items-center gap-2 text-sm text-rose-50/70 hover:text-rose-300 transition-colors">
                  <MessageCircle className="w-3.5 h-3.5" />
                  AIチャット
                </Link>
              </li>
            </ul>
          </div>

          {/* サービスについて */}
          <div>
            <h3 className="text-xs font-bold text-rose-200 uppercase tracking-wider mb-4">ウラカルテについて</h3>
            <ul className="space-y-2.5">
              <li>
                <Link to="/about" className="text-sm text-rose-50/70 hover:text-rose-300 transition-colors">
                  運営について（公式）
                </Link>
              </li>
              <li>
                <Link to="/evidence-submit" className="text-sm text-rose-50/70 hover:text-rose-300 transition-colors">
                  エビデンス提出
                </Link>
              </li>
              <li>
                <Link to="/terms" className="inline-flex items-center gap-2 text-sm text-rose-50/70 hover:text-rose-300 transition-colors">
                  <FileText className="w-3.5 h-3.5" />
                  利用規約
                </Link>
              </li>
              <li>
                <Link to="/privacy" className="inline-flex items-center gap-2 text-sm text-rose-50/70 hover:text-rose-300 transition-colors">
                  <Lock className="w-3.5 h-3.5" />
                  プライバシーポリシー
                </Link>
              </li>
              <li>
                <Link to="/contact" className="inline-flex items-center gap-2 text-sm text-rose-50/70 hover:text-rose-300 transition-colors">
                  <Mail className="w-3.5 h-3.5" />
                  お問い合わせ
                </Link>
              </li>
            </ul>
            <div className="mt-6">
              <h3 className="text-xs font-bold text-rose-200 uppercase tracking-wider mb-3">データソース</h3>
              <div className="inline-flex items-center gap-2 px-3 py-1.5 bg-white/5 rounded-full text-xs text-rose-50/60">
                <Twitter className="w-3.5 h-3.5" />
                <span>X (Twitter) API × Gemini AI</span>
              </div>
            </div>
            <div className="mt-6">
              <h3 className="text-xs font-bold text-rose-200 uppercase tracking-wider mb-3">関連サービス</h3>
              <a
                href={buildSeoulMatchUrl('footer')}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 text-sm text-rose-50/70 hover:text-sky-300 transition-colors"
              >
                <Plane className="w-3.5 h-3.5" />
                Seoul Match — 韓国ひとり旅の旅仲間探し
              </a>
              <p className="mt-1.5 text-[11px] text-rose-50/40">
                渡韓中の食事・観光仲間や、ダウンタイム中の話し相手が見つかる姉妹サービスです（外部サイト）。
              </p>
            </div>
          </div>
        </div>

        <div className="mt-10">
          <GlossaryDetails />
        </div>

        {/* 区切り線＋コピーライト */}
        <div className="mt-6 pt-6 border-t border-white/10">
          <div className="flex flex-col sm:flex-row justify-between items-center gap-3">
            <p className="text-xs text-rose-50/40">
              &copy; {currentYear} ウラカルテ. All rights reserved.
            </p>
            <div className="flex items-center gap-4">
              <Link to="/terms" className="text-xs text-rose-50/40 hover:text-rose-300 transition-colors">
                利用規約
              </Link>
              <Link to="/privacy" className="text-xs text-rose-50/40 hover:text-rose-300 transition-colors">
                プライバシーポリシー
              </Link>
              <Link to="/contact" className="text-xs text-rose-50/40 hover:text-rose-300 transition-colors">
                お問い合わせ
              </Link>
            </div>
          </div>
          <p className="text-xs text-rose-50/30 text-center mt-3">
            口コミはXユーザーの投稿を元にAIが分析しています。内容の正確性を保証するものではありません。
          </p>
        </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
